import React, { FunctionComponent } from 'react';
import styled from 'styled-components/macro';
import { theme } from '../../../theme';
import PaddedContent from '../PaddedContent';
import { DeviceSize } from '../../basic/DeviceSize';
import { H4, LinkButton } from '../../common';

interface InfoBlockProps {
  title: string;
  hasLink: boolean | undefined;
  linkLabel?: string;
  linkTo?: string;
}

const InfoBlock: FunctionComponent<InfoBlockProps> = ({ title, hasLink, linkLabel, linkTo, children }) => {
  return (
    <PaddedContent paddingTop="0" mobilePaddingTop="0" mobilePaddingBottom="20">
      <BlockContainer>
        <H4>{title}</H4>
        <ContentContainer>{children}</ContentContainer>
        {hasLink && linkTo && (
          <LinkButton className="infoBlockLink" to={linkTo} size="small" iconRight icon={'arrowForward'}>
            {linkLabel}
          </LinkButton>
        )}
      </BlockContainer>
    </PaddedContent>
  );
};

const BlockContainer = styled.div`
  display: flex;
  width: 100%;
  border-top: 2px solid ${theme().colors.m2Black};
  padding-top: 16px;
  position: relative;

  div,
  p {
    margin: 0;
  }

  h4 {
    width: 25%;
  }

  .infoBlockLink {
    position: absolute;
    right: 0;
    top: 16;
  }

  @media ${DeviceSize.desktopS} {
    flex-direction: column;

    h4 {
      width: 75%;
      margin-bottom: 24px;
    }
  }
`;

const ContentContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  line-height: 21px;

  dl {
    width: 100%;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  dt {
    font-weight: 700;
    width: 144px;
  }

  dd {
    height: auto;
    margin-left: 10px;
    flex: 1;
    min-width: 0;
  }

  a {
    color: ${theme().colors.m2Black};
    text-decoration: underline;
  }

  @media ${DeviceSize.desktopS} {
    width: 100%;
  }
`;

export const RowContainer = styled.div`
  width: 100%;

  display: flex;
  padding: 10px 0;

  :not(:last-of-type) {
    border-bottom: 1px solid ${theme().colors.m2Black20};
  }
`;

export default InfoBlock;
